import { t } from "i18next";
import { useContext, useEffect } from "react";
import { ProductContext, MountingContext } from "../../App";
import wingLeft from "../../images/mountingIcons/belgium-wing-left.svg";
import wingMiddle from "../../images/mountingIcons/belgium-wing-middle.svg";
import wingRight from "../../images/mountingIcons/belgium-wing-right.svg";

const WING_LEFT = "wingLeft";
const WING_MIDDLE = "wingMiddle";
const WING_RIGHT = "wingRight";
const TOP = "top";
const RIGHT = "right";
const BOTTOM = "bottom";
const MIDDLE = "middle";
const LEFT = "left";

function SectionMountings() {
  const { currentProduct } = useContext(ProductContext);
  const {
    topMounting,
    setTopMounting,
    selectedWing,
    setSelectedWing,
    rightMounting,
    setRightMounting,
    bottomMounting,
    middleMounting,
    setMiddleMounting,
    setBottomMounting,
    leftMounting,
    setLeftMounting,
  } = useContext(MountingContext);

  useEffect(() => {
    if (currentProduct) {
      setTopMounting(currentProduct[selectedWing][TOP].visible);
      setRightMounting(currentProduct[selectedWing][RIGHT].visible);
      setMiddleMounting(currentProduct[selectedWing][MIDDLE].visible);
      setBottomMounting(currentProduct[selectedWing][BOTTOM].visible);
      setLeftMounting(currentProduct[selectedWing][LEFT].visible);
    }
  });

  const setMountings = {
    [TOP]: setTopMounting,
    [RIGHT]: setRightMounting,
    [BOTTOM]: setBottomMounting,
    [MIDDLE]: setMiddleMounting,
    [LEFT]: setLeftMounting,
  };

  function onWingSelection(event) {
    setSelectedWing(event.target.id);
    setTopMounting(currentProduct[selectedWing][TOP].visible);
    setRightMounting(currentProduct[selectedWing][RIGHT].visible);
    setMiddleMounting(currentProduct[selectedWing][MIDDLE].visible);
    setBottomMounting(currentProduct[selectedWing][BOTTOM].visible);
    setLeftMounting(currentProduct[selectedWing][LEFT].visible);
  }

  function onMountingChange(event) {
    currentProduct[selectedWing][event.target.name].visible = event.target.checked;
    setMountings[event.target.name](currentProduct[selectedWing][event.target.name].visible);
  }

  return (
    <section className="panel-container__section">
      <header className="section__title mounting__header">
        <span>{t('mountings')}</span>
        <div>
          <button>
            <img
              id={WING_LEFT}
              src={wingLeft}
              className={`mounting__wing ${selectedWing === WING_LEFT ? "mounting__wing--selected" : ""}`}
              alt="Window model with 3 lanes and 3 wings with the left wing selected for mounting updates."
              onClick={onWingSelection.bind(this)}
            />
          </button>
          <button>
            <img
              id={WING_MIDDLE}
              src={wingMiddle}
              className={`mounting__wing ${selectedWing === WING_MIDDLE ? "mounting__wing--selected" : ""}`}
              alt="Window model with 3 lanes and 3 wings with the left wing selected for mounting updates."
              onClick={onWingSelection.bind(this)}
            />
          </button>
          <button>
            <img
              id={WING_RIGHT}
              src={wingRight}
              className={`mounting__wing ${selectedWing === WING_RIGHT ? "mounting__wing--selected" : ""}`}
              alt="Window model with 3 lanes and 3 wings with the right wing selected for mounting updates."
              onClick={onWingSelection.bind(this)}
            />
          </button>
        </div>
      </header>
      <div className="window-size__sliders">
        <div className="section__row--center">
          <input
            type="checkbox"
            name={TOP}
            checked={topMounting}
            onChange={onMountingChange.bind(this)}
          ></input>
          <label htmlFor={TOP}>{t('top')}</label>
        </div>
        <div className="section__row--center">
          <input
            type="checkbox"
            name={RIGHT}
            checked={rightMounting}
            onChange={onMountingChange.bind(this)}
          ></input>
          <label htmlFor={RIGHT}>{t('right')}</label>
        </div>
        <div className="section__row--center">
          <input
            type="checkbox"
            name={MIDDLE}
            checked={middleMounting}
            onChange={onMountingChange.bind(this)}
          ></input>
          <label htmlFor={MIDDLE}>{t('middle')}</label>
        </div>
        <div className="section__row--center">
          <input
            type="checkbox"
            name={BOTTOM}
            checked={bottomMounting}
            onChange={onMountingChange.bind(this)}
          ></input>
          <label htmlFor={BOTTOM}>{t('bottom')}</label>
        </div>
        <div className="section__row--center">
          <input
            type="checkbox"
            name={LEFT}
            checked={leftMounting}
            onChange={onMountingChange.bind(this)}
          ></input>
          <label htmlFor={LEFT}>{t('left')}</label>
        </div>
      </div>
    </section>
  );
}

export default SectionMountings;
